module.exports = __webpack_public_path__ + "static/img/fullscreen-image_hero.2584709.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/policy-manual-wizard/fullscreen-image_hero.png
// module id = EQq/
// module chunks = 0